import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useStore } from "react-admin";
import SaveForm from "./SaveForm";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { errorMessages } from "app";

const STORE_KEY = "internshipCyclesSchedule.filters";

const CreateScheduleCycleStream = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  return (
    <>
      <Create
        title="Създаване на поток за преддипломен стаж"
        actions={<BackButtonToolbar />}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
            planId: filters?.planId,
          }}
        >
          <SaveForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateScheduleCycleStream;
